export default __webpack_public_path__ + "static/media/Twitter_Logo_Blue.d386ccd6.svg";